module.exports = __webpack_public_path__ + "img/empty.67cedf76.svg";